// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__25ewV","label":"SetPasswdForm_label__3T7ia"};